import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';

//CSS
import '../../LandingSubcomponents/Servicios.css';


class MonitoreoDigital extends Component {
    render() {

        return (
            <Row className="monitoreo-digital">
                <Col md={6} xsHidden smHidden className="monitoreo-seccion-izquierda">

                </Col>
                <Col md={6} sm={12} xs={12} className="monitoreo-seccion-derecha">
                    <Row>
                        <Col md={7} sm={12} xs={12} className="monitoreo-descripcion wow animated bounceInRight" data-wow-duration="1s">
                            <h3>
                                Monitoreo digital
                            </h3>
                            <h4>
                                Contamos con tecnología de geoposicionamiento en todos nuestros vehículos de transporte
                                para
                                poder brindar un excelente servicio de despacho de mercadería en tiempo record.
                            </h4>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}


export default MonitoreoDigital;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Servicios/MonitoreoDigital.js